import { render, staticRenderFns } from "./DefinitionParameterUserSelection.vue?vue&type=template&id=1895f872&scoped=true&"
import script from "./DefinitionParameterUserSelection.vue?vue&type=script&lang=js&"
export * from "./DefinitionParameterUserSelection.vue?vue&type=script&lang=js&"
import style0 from "./DefinitionParameterUserSelection.vue?vue&type=style&index=0&id=1895f872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895f872",
  null
  
)

export default component.exports